// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__10Uty","colMaxWidth":"Table_colMaxWidth__34eHn"};